// extracted by mini-css-extract-plugin
module.exports = {"picWrapper":"BosIconSelectorWidget_picWrapper__MVjqY","imageWrapper":"BosIconSelectorWidget_imageWrapper__25ig1","button":"BosIconSelectorWidget_button__J6Gv6"};